<template>
  <div v-if="theme != null">
    <h3>{{theme.name}}</h3>

    <div class="preview" :style="{color: theme[variant].normal.message, backgroundColor: backgroundColor}">
      <message v-for="(color, i) in theme[variant].nickColors" :key="i" :nickColor="color" :variant="theme[variant]" type="normal">
        Hello
      </message>
      
      <message v-for="(color, i) in theme[variant].nickColors" :key="'a' + i" :nickColor="color" :variant="theme[variant]" type="action">
        <em>tested this theme with a large trout</em>
      </message>

      <message v-for="(color, i) in theme[variant].nickColors" :key="'m' + i" :nickColor="color" :variant="theme[variant]" type="mention">
        <strong :style="{color: theme[variant].ownNick}">Palaver</strong>: yo, what's up?
      </message>
      
      <message v-for="(color, i) in theme[variant].nickColors" :key="'n' + i" :nickColor="color" :variant="theme[variant]" type="notice">
        server going down in 120 seconds!
      </message>
      
      <message v-for="(color, i) in theme[variant].nickColors" :key="'s' + i" :nickColor="color" :variant="theme[variant]" type="status">
        has joined #palaver
      </message>
    </div>
  </div>
</template>

<script>
import Message from './Message.vue'

export default {
  name: 'preview',
  props: ['theme', 'variant'],
  computed: {
    backgroundColor() {
      const defaultColor = this.theme[this.variant].normal.background

      if (defaultColor != null) {
        return defaultColor
      } else if (this.variant == 'light') {
        return 'white' 
      }

      return 'black'
    }
  },
  components: { Message }
}
</script>

<style scoped>
h3 {
  font-family: Montserrat, sans-serif;
  font-weight: bold;
  margin:  30px 30px 10px;
}

.preview {
  margin: 0 30px 30px;
  border: 1px solid #d9e3ef;
  border-radius: 0.675rem;
  overflow: hidden;
  box-shadow:0 0 25px rgba(17, 51, 102, 0.06), 0 20px 25px rgba(17, 51, 102, 0.06), 0 3px 4px rgba(17, 51, 102, 0.06);
}
</style>
